import LOGO from "./leumi-logo.svg";
import LOGO_WIDE from "./leumi-logo-wide.svg";
import SUCCESS from "./leumi-logo-wide.svg";
import CIRCLE_TRASH from "./circle-trash.svg";
import CIRCLE_INFO from "./circle-info.svg";
import ILS from "./ILS.svg";
import CHEVRON_RIGHT from "./chevron-right.svg";
import CHEVRON_LEFT from "./chevron-left.svg";
import ELLIPSE from "./ellipse.svg";
import ELLIPSE_SELECTED from "./ellipse-selected.svg";
import PENCIL from "./pencil.svg"

export default {
  LOGO,
  LOGO_WIDE,
  SUCCESS,
  CIRCLE_TRASH,
  CIRCLE_INFO,
  ILS,
  CHEVRON_RIGHT,
  CHEVRON_LEFT,
  ELLIPSE,
  ELLIPSE_SELECTED,
  PENCIL
};
